/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState, useEffect } from 'react';
// react component that copies the given text inside your clipboard
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { NavLink as NavLinkRRD, Link } from 'react-router-dom';
// reactstrap components
import {
  Card,
  Button,
  NavLink,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  CardTitle,
  UncontrolledTooltip,
  Modal,
} from 'reactstrap';
import { chartOptions, parseOptions, chartExample2 } from 'variables/charts.js';
import { Line, Bar } from 'react-chartjs-2';
import Chart from 'chart.js';
import axiosInstance from './../../helpers/axiosInstance';
import ReactCircleModal from 'react-circle-modal';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRangePicker, defaultStaticRanges } from 'react-date-range';
import Slicer from 'react-slicer';
import 'react-slicer/build/react-slicer.css';
import { useDispatch, useSelector } from 'react-redux';
import { cambiavalorpago, actualizarCheckboxs, actualizaropcionpago, actualizarBotonPagar } from 'Silicerreducerpayu';
import {
  cambiaruta,
  cambiasidebar,
  desactivasidebar,
  actulizaInitHome,
} from '../../Slicersreducers';
import NumberFormat from 'react-number-format';
import { es } from 'date-fns/locale';
import GenerateExcel from './GenerateExcel';
import MovementsProducts from './MovementsProducts';
import Comppago from './Payu'
import { Fragment } from 'react';

const BasicData = (props) => {
  const [permisos, setPermisos] = useState()
  const habilitarBotonPagar = useSelector((state) => state.pagopayu.botonpagar)
  const convierteFecha = (fecha) => {
    let newFecha = fecha;
    let fecha400 = '';
    if (newFecha.getMonth() + 1 < 10) {
      fecha400 =
        newFecha.getFullYear() + '0' + (newFecha.getMonth() + 1) + fecha400;
    } else {
      fecha400 =
        newFecha.getFullYear() + '' + (newFecha.getMonth() + 1) + fecha400;
    }
    if (newFecha.getDate() < 10) {
      fecha400 = fecha400 + '0' + newFecha.getDate();
    } else {
      fecha400 = fecha400 + newFecha.getDate();
    }
    return fecha400;
  };

  const obtenerCookie = (name) => {
    let value = "; " + document.cookie;
    let parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  }

  function formatearFecha(fecha) {
    let newFecha = fecha;
    let formatFecha = '';
    let month;
    let year;
    let date;

    if (newFecha.getMonth() + 1 < 10) {
      month = '0' + (newFecha.getMonth() + 1);
    } else {
      month = newFecha.getMonth() + 1;
    }
    if (newFecha.getDate() < 10) {
      date = '0' + newFecha.getDate();
    } else {
      date = newFecha.getDate();
    }
    year = newFecha.getFullYear();
    formatFecha = `${date}/${month}/${year}`;

    return formatFecha;
  }
  const [MovColoc, setMovColoc] = useState([]);
  const [pagomin, setpagomin] = useState(0);
  const [pagotot, setpagotot] = useState(0);
  const [balance, setbalance] = useState(0);
  const [Descript, setDescript] = useState('');
  const [Type, setType] = useState('');
  const [newFechaI, setnewFechaI] = useState(new Date());
  const [newFechaF, setnewFechaF] = useState(new Date());
  const [dataAlert, setdataAlert] = useState([])
  const [isLoading, setIsLoading] = useState(false);
  const [rangoFechas, setrangoFechas] = useState([
    {
      startDate: newFechaI,
      endDate: newFechaF,
      key: 'selection',
    },
  ]);
  const [dataJson, setDataJson] = useState([]);
  const [filterMov, setfilterMov] = useState(false);
  const [stateopcpago,setstateopcpago]=useState(false);
  var minDate = new Date();
  minDate.setMonth(minDate.getMonth() - 12);
  const dispacher = useDispatch();

  useEffect(async () => {
    dispacher(cambiaruta('Inicio/Movimientos'));
    dispacher(cambiasidebar(false));
    dispacher(desactivasidebar());
    dispacher(actulizaInitHome(false));
    let valorCookie = obtenerCookie("TEMPORAL")
    if(valorCookie.length>3){
      let ultimaPosicion = valorCookie.substring(3,4);
      console.log("valor tomado coockie " + ultimaPosicion)
      if (ultimaPosicion == "1"){
        setPermisos(true)
      }
      else{
        setPermisos(false)
      }
    }
    else{
      setPermisos(false)
    }
    console.log("Cookie TEMPORAL: " + obtenerCookie("TEMPORAL"))
    const apiUrl = '/WSGYG39_2/api/Inquiries/Products';
    const res = await axiosInstance()
      .get(apiUrl)
      .catch((err) => {
        alert('Hay un problema. Vuelve atras');
      });
    if (res != 'err') {
      let saldo = 0;
      let descripcion;
      let type;
      console.log(
        'esta es la repuesta de Products ########' +
          JSON.stringify(res, 2, null)
      );
      for (let i = 0; i < res.data.summaryProducts.products.length; i++) {
        if (
          res.data.summaryProducts.products[i].accountNumber ==
          props.accountNumber
        ) {
          saldo = res.data.summaryProducts.products[i].balance;
          type = res.data.summaryProducts.products[i].accountType;
          descripcion = res.data.summaryProducts.products[i].description;
          console.log(
            `Este es el tipo del prestamo: ${type}, y el indice: ${i}`
          );
        }
      }
      setType(type);
      setbalance(saldo);
      setDescript(descripcion);
    }

    const apiPry = '/WSGYG39_2/api/Inquiries/Projection';

    const user = {
      AccountNumber: props.accountNumber,
      Parameters: [props.accountNumber],
    };
    const resPry = await axiosInstance()
      .post(apiPry, user)
      .catch((err) => {
        return 'err';
      });
    if (resPry != 'err') {
      for (let i = 0; i < resPry.data.value.itemProyection.length; i++) {
        if (resPry.data.value.itemProyection[i].nameItem == 'Pago Minimo') {
          setpagomin(resPry.data.value.itemProyection[i].valueItem);
        }
        if (resPry.data.value.itemProyection[i].nameItem == 'Pago Total') {
          setpagotot(resPry.data.value.itemProyection[i].valueItem);
        }
      }
    }
  }, MovColoc);

  const buscaMov = async () => {
    setfilterMov(true);
    const entradaMovimientos = {
      accountNumber: props.accountNumber,
      parameters: [
        props.accountNumber,
        convierteFecha(newFechaI),
        convierteFecha(newFechaF),
      ],
    };
    const apiUrlMov = '/WSGYG39_2/api/Inquiries/LoansMovements';
    const resmov = await axiosInstance()
      .post(apiUrlMov, entradaMovimientos)
      .catch((err) => {
        setMovColoc([]);
        alert('Hay un problema. Vuelve atras');
      });
    if (resmov != 'err') {
      setMovColoc(resmov.data.transactionHistory);
    }
  };

  const ListMovimientos = (props) => {
    return (
      <div className="col-md-12">
        <Slicer initialPage={1} itemsPerPage={10}>
          {props.historicoTransacciones.map((item, index) => {
            return (
              <Card
                className="shadow col-md-12"
                style={{ padding: 20 + 'px', margin: '5px 15px 15px 15px' }}
              >
                <div className="">
                  <Row style={{ alignItems: 'center' }}>
                    <div
                      className="col-auto mr-3"
                      style={{ alignItems: 'center' }}
                    >
                      <p style={{ marginBottom: 0, fontSize: '12px' }}>
                        {item.transactionDate.substring(0, 4)}
                        <br />
                        {item.transactionDate.substring(5)}
                      </p>
                    </div>
                    <div className="col">
                      <Row>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginLeft: 0 + 'px',
                          }}
                        >
                          <p
                            style={{
                              fontWeight: 700,
                              margin: '2px 0 0 0px',
                              fontSize: '12px',
                            }}
                          >
                            {item.transactionName}
                          </p>
                        </div>
                      </Row>
                      <Row>
                        <span
                          style={{
                            marginBottom: 0,
                            fontWeight: 700,
                            fontSize: '12px',
                          }}
                          class="mb-2 text-sm"
                        >
                          Credito No. {props.accountNumber}
                        </span>
                      </Row>
                    </div>
                    <div className="col-auto mr-3 vertical-center">
                      <h6
                        style={{
                          fontWeight: 600,
                          fontSize: 1 + 'rem',
                          marginBottom: 0,
                        }}
                      >
                        <i className="fas fa-dollar-sign" />
                        {item.sign}
                        {item.transactionBalance}
                      </h6>
                    </div>
                  </Row>
                </div>
              </Card>
            );
          })}
        </Slicer>
      </div>
    );
  };

  const Alerts = (props) => {
    var data = props.data;
    var newsTemplate;
    if (data.length > 0) {
      newsTemplate = data.map(function (item, index) {
        return (
          <div class={item.type} role="alert">
            <button
              type="button"
              class="close"
              aria-label="Close"
              onClick={() => deleteAlert(item)}
            >
              <span aria-hidden="true">×</span>
            </button>
            <span className="alert-inner--icon mr-3">
              <i className={item.icon} />
            </span>{' '}
            <span class="alert-inner--text">{item.description}</span>
          </div>
        );
      });
    }
    return <div className="toast-bottom-right">{newsTemplate}</div>;
  };

  const deleteAlert = (alert) => {
    setdataAlert(dataAlert.filter((auxAlert) => auxAlert != alert));
  };
  const deleteTimeAlert = () => {
    setTimeout(function () {
      setdataAlert([]);
    }, 5000);
  };

  const functionListMov = (lista) => {
    setMovColoc(lista);
  };

   
  const iniciapago= async (ele) =>{
    const apiHor = "/WSGYG39_2/api/Consultas/HorarioPermitido"
    const reqsHor = {
      "indicadorHorario": "1"
    }
    setIsLoading(true)
    const peticionHorario = await axiosInstance()
      .post(apiHor, reqsHor)
      .catch((err) => {
        console.log(err)
        setdataAlert(
          err.response.data.errors.map((e) => ({
            ...e,
            type: "alert alert-alert show alert-dismissible fade alert-danger",
            icon: "fas fa-exclamation-circle",
          }))
        )
        return "err";
      })

      if (peticionHorario != "err") {
        setstateopcpago(ele)
        setIsLoading(false)
      }
      else {
        setIsLoading(false)
      }
  }
  const desopcpago = (mensajeAlerta, tipoAlerta, iconoAlerta) => {
    debugger
    setstateopcpago(false)
    setdataAlert(
      [{
        description: mensajeAlerta,
        type: tipoAlerta,
        icon: iconoAlerta,
      }]
    );
    deleteTimeAlert()
  }

  if(stateopcpago){
    return(
      <Comppago Descript={Descript} 
        accountNumber={props.accountNumber} 
        balance={balance} 
        pagotot={pagotot} 
        pagomin={pagomin}
        funcionpadre={desopcpago}>
      </Comppago>
    )
  }else{
    return (
      <div lg="12" xl="12" className="" style={{ width: 100 + '%' }}>
        <Card className="mb-xl-0 shadow pl-5 pr-5">
          <div className="bg-transparent row m-0">
            <div class="card-profile-stats d-flex justify-content-init col">
              <div style={{ textAlign: 'left' }}>
                <span class="heading">{Descript}</span>
                <span class="description">No. {props.accountNumber}</span>
              </div>
            </div>
          </div>
          <CardBody className="pb-1 row">
            <div className="col-md-12">
              <Row className='flexcolumcenter' style={{ marginBottom: 30 + 'px' }}>
                <div className='detalleprestamoscont'>
                  <div className='flexcolumleftw90'>
                    <div >
                      <h6 style={{ fontSize: 1 + 'rem', fontWeight: 500 }}>
                        {' '}
                        Valor Deuda{' '}
                      </h6>
                      <h5 style={{ fontSize: 1.25 + 'rem' }}>
                        <NumberFormat
                          value={balance}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                        />
                      </h5>
                    </div>
                    <div>
                      <h6 style={{ fontSize: 1 + 'rem', fontWeight: 500 }}>
                        {' '}
                        <i className="fas fa-money-bill" /> Pago Total a la Fecha{' '}
                      </h6>
                      <h5 style={{ fontSize: 1.25 + 'rem' }}>
                        <NumberFormat
                          value={pagotot}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                        />
                      </h5>
                    </div>
                  </div>
                  <div className='flexcolumrigthw90'>
                    <div >
                      <h6 style={{ fontSize: 1 + 'rem', fontWeight: 500 }}>
                        {' '}
                        <i className="fas fa-money-bill" /> Pago Mínimo a la Fecha
                      </h6>
                      <h5 style={{ fontSize: 1.25 + 'rem' }}>
                        {' '}
                        <NumberFormat
                          value={pagomin}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                        />{' '}
                      </h5>
                      {/*
                        permisos ?
                        <button
                        disabled={habilitarBotonPagar}
                        className="btn btn-success"
                        onClick={()=>iniciapago(true)}
                        >
                        {' '}
                        Pagar
                        </button> : <Fragment></Fragment>
                      */}
                    </div>
                  </div>
                </div>
              </Row>
            </div>
  
            <div
              className="col-md-12"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                position: 'relative',
                margin: '24px 15px',
              }}
            >
              <h4 style={{ fontWeight: 600, fontSize: 28 + 'px' }}>
                Mis movimientos
              </h4>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <p style={{ fontWeight: 400, margin: 0 }}>
                  {' '}
                  Desde{' '}
                  <b>
                    {newFechaI.getFullYear() +
                      '/' +
                      (newFechaI.getMonth() + 1) +
                      '/' +
                      newFechaI.getDate()}
                  </b>{' '}
                  hasta{' '}
                  <b>
                    {newFechaF.getFullYear() +
                      '/' +
                      (newFechaF.getMonth() + 1) +
                      '/' +
                      newFechaF.getDate()}
                  </b>
                </p>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: 10 + 'px',
                  }}
                >
                  <ReactCircleModal
                    backgroundColor=""
                    toogleComponent={(onClick) => (
                      <button className="btn btn-success" onClick={onClick}>
                        <i className="fas fa-calendar-alt" />
                      </button>
                    )}
                    // Optional fields and their default values
                    offsetX={'50%'}
                    offsetY={'50%'}
                  >
                    {(onClick) => (
                      <div style={{ padding: '1em' }}>
                        <Row>
                          <DateRangePicker
                            onChange={(item) => {
                              setrangoFechas([item.selection]);
                              setnewFechaI(item.selection.startDate);
                              setnewFechaF(item.selection.endDate);
                            }}
                            minDate={minDate}
                            showSelectionPreview={true}
                            moveRangeOnFirstSelection={false}
                            months={1}
                            ranges={rangoFechas}
                            direction="horizontal"
                            lang="es"
                            locale={es}
                            staticRanges={[
                              {
                                ...defaultStaticRanges[0],
                                label: 'Hoy',
                              },
                              {
                                ...defaultStaticRanges[1],
                                label: 'Ayer',
                              },
                              {
                                ...defaultStaticRanges[2],
                                label: 'Esta Semana',
                              },
                              {
                                ...defaultStaticRanges[3],
                                label: 'La Última Semana',
                              },
                              {
                                ...defaultStaticRanges[4],
                                label: 'Este Mes',
                              },
                              {
                                ...defaultStaticRanges[5],
                                label: 'Último Mes',
                              },
                            ]}
                            inputRanges={[]}
                          />
                        </Row>
                        <Row>
                          <button onClick={onClick} className="btn btn-success">
                            Cerrar calendario
                          </button>
                        </Row>
                      </div>
                    )}
                  </ReactCircleModal>
                  <button
                    className="btn btn-success"
                    onClick={buscaMov}
                    style={{ margin: '1em' }}
                  >
                    {' '}
                    Filtrar
                  </button>
                  {MovColoc.length != 0 ? (
                    <GenerateExcel
                      indicador="2"
                      nombre={Descript}
                      numero={props.accountNumber}
                      fecha={formatearFecha(newFechaI)}
                      deuda={balance}
                      pagoTotalFecha={pagotot}
                      pagoMinimoFecha={pagomin}
                      movCuenta={MovColoc}
                    ></GenerateExcel>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
            {Type != '' ? (
              filterMov ? (
                <ListMovimientos
                  historicoTransacciones={MovColoc}
                  accountNumber={props.accountNumber}
                ></ListMovimientos>
              ) : (
                <MovementsProducts
                  product={props}
                  type={Type}
                  functionListMov={functionListMov}
                ></MovementsProducts>
              )
            ) : (
              ''
            )}
          </CardBody>
        </Card>
        <Alerts
        data={dataAlert} />
        <Modal
          className="modal-dialog-centered"
          contentClassName="bg-transparent shadow-none"
          isOpen={isLoading}
          >
            <div
              tabIndex="-1"
              style={{
              position: "relative",
              zIndex: "1050",
              display: "block",
              width: "100%",
              height: "80vh"
              }}
              >
                <div
                style={{
                textAlign: "center",
                top: "50%",
                position: "relative"
                }}
                >
                <img
                style={{ height: "100px" }}
                src={require("../../assets/img/icons/LoaderIDEA.gif").default}
                ></img>
                </div>
                <div class="modal-backdrop fade show"></div>
                </div>
          </Modal>
      </div>
    );

  }
  
};



const Movements = (props) => {
  const [accountNumber, setaccountNumber] = useState(
    props.location.state.accountNumber
  );
  return (
    <>
      <div className="pb-1 pt-1 pt-md-8">
        <Container fluid>
          <div className="header-body">
            <Row>
              <BasicData accountNumber={accountNumber}></BasicData>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Movements;
